import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { sessionQueryKeys, updateMe } from '@/entities/session';
import { changeUiLanguage } from '@/shared/config';
import type { UiLanguage } from '@/shared/lib';
import { notifyError } from '@/shared/ui';

/**
 * Смена языка интерфейса (World: EN/ES, ТЗ ACC 4.7.1). Для вошедшего участника язык сохраняется
 * в профиле (PATCH /admin/me `{admin_locale}` → TeamMember.admin_locale). Тексты с сервера (меню,
 * сообщения) зависят от Accept-Language, поэтому активные запросы перезапрашиваются.
 */
export function useChangeLanguage() {
  const queryClient = useQueryClient();
  return useCallback(
    async (language: UiLanguage) => {
      await changeUiLanguage(language);
      if (queryClient.getQueryData(sessionQueryKeys.me) !== undefined) {
        try {
          queryClient.setQueryData(sessionQueryKeys.me, await updateMe({ admin_locale: language }));
        } catch (error) {
          notifyError(error);
        }
      }
      await queryClient.invalidateQueries();
    },
    [queryClient],
  );
}
